<div class="wrapper" [class.wrapper--inline]="isInline">
    <app-dialog-title
    *ngIf="!isInline"
    class="header"
    [title]="(isCreatingOnly ?'pages.collections.dialogs.edit-aeras-dialog.create-title' :  'pages.collections.dialogs.edit-aeras-dialog.modify-title') | translate"
    (close)="close()"
    ></app-dialog-title>

    <ng-container [ngSwitch]="isInline">
      <ng-container *ngSwitchCase="false">
        <mat-dialog-content>
          <ng-container *ngTemplateOutlet="areasContent"></ng-container>
        </mat-dialog-content>
      </ng-container>
      <ng-container *ngSwitchCase="true">
        <ng-container *ngTemplateOutlet="areasContent"></ng-container>
      </ng-container>
    </ng-container>

    <ng-template #areasContent>
      <ng-container *ngIf="!isCreatingOnly; else creatingOnlyTemplate">
        <div class="section-add-area section-add-area--top" *ngIf="isInline">
          <button class="bciti-button bciti-button--blue"
            *ngIf="toggleAddButton"
            (click)="startCreating()">
            {{ 'pages.collections.list.button.add-area' | translate }}
          </button>
        </div>
        <div class="areas-list" [class.loading]="loading">
          <ng-container *ngIf="loading">
            <mat-progress-spinner mode="indeterminate" diameter="20"></mat-progress-spinner>
          </ng-container>
          <ng-container *ngIf="!loading">
            <ng-container *ngIf="areas$ | async as areas">
              <app-bciti-category-input
                *ngFor="let area of areas; let i = index"
                [category]="area"
                [disabled]="disableActions"
                [canDelete]="areas.length === 1 ? false : true"
                [textInputHint]="null"
                (onFormOpen)="closeAllOtherForms($event)"
                (onDelete)="deleteArea($event)"
                (onSave)="handleSave($event)"
                [propertyLabelInput]="propertyLabelInput.AREA"
                (cancelCreate)="handleCancelCreate()"
                (currentState)="toggleAddButtonDisplay($event)"
              ></app-bciti-category-input>
            </ng-container>
          </ng-container>
        </div>
        <div class="section-add-area" *ngIf="!isInline">
          <button class="bciti-button bciti-button--blue"
            *ngIf="toggleAddButton"
            (click)="startCreating()">
            {{ 'common.add' | translate }}
          </button>
        </div>
        <div class="section-add-area">
          <app-bciti-category-input
            *ngIf="creating"
            [disabled]="disableActions"
            [textInputHint]="null"
            [propertyLabelInput]="propertyLabelInput.AREA"
            (cancelCreate)="handleCancelCreate()"
            (onSave)="handleSave($event)"
          ></app-bciti-category-input>
        </div>
      </ng-container>

      <ng-template #creatingOnlyTemplate>
        <app-bciti-category-input
        [disabled]="disableActions"
        [textInputHint]="null"
        [displayCloseButton]="false"
        [propertyLabelInput]="propertyLabelInput.AREA"
        (cancelCreate)="handleCancelCreatingOnly()"
        (onSave)="handleSaveCreateOnly($event)"
      ></app-bciti-category-input>
    </ng-template>
    </ng-template>
</div>